
document.addEventListener('DOMContentLoaded' , () =>{
	//header gnb
	const body = document.body,
		  gnbOpenBtn = document.querySelectorAll('.js-gnb-open'),
		  gnbCloseBtn = document.querySelector('.js-gnb-close'),
		  gnbToggleBtn = document.querySelectorAll('.js_gnb_toggleBtn'),
		  gnbDepth2 = document.querySelectorAll('.depth2');

	if(document.querySelector('.gnb')){
		gnbOpenBtn.forEach(function(el){
			el.addEventListener('click' , function(){
				body.classList.add('ovf');
				document.querySelector('.js-gnb').classList.add('on');
				setTimeout(function(){
					document.querySelector('.js-gnb').classList.add('active');
				}, 10)

				gnbToggleBtn.forEach(function(el){
					let gnbToggleBtnArray = Array.from(el.parentNode.parentNode.querySelectorAll('.js_gnb_toggleBtn'));

					el.addEventListener('click' , function(e){
						gnbToggleBtnArray.forEach(function(el){
							el.classList.remove('active');
						});
						el.classList.add('active');
					});
				})

				//gnb depth2 전체보기 하나일 때 col1 class 추가
				gnbDepth2.forEach(function(el){
					let targetLi = el.querySelectorAll('li').length;

					if(targetLi == 1){
						el.classList.add('col1');
					}
				})

				gnbCloseBtn.addEventListener('click' , function(){
					body.classList.remove('ovf');
					document.querySelector('.js-gnb').classList.remove('active');
					setTimeout(function(){
						document.querySelector('.js-gnb').classList.remove('on');
					}, 500)
				});
			});
		})

		document.querySelector('.gnb .arrow-menu li:first-child .js_gnb_toggleBtn').classList.add('active');
	}

	//header height
	const content = document.querySelector('.content');
	const header = document.getElementById('header');
	const lnb = document.querySelector('.lnb');

	function setContentMargin() {
		if (!content || !header) return;

		const headerH = header.offsetHeight;
		const lnbH = lnb ? lnb.offsetHeight : 0;

		content.style.marginTop = `${headerH + lnbH}px`;
	}

	window.addEventListener('load', setContentMargin);
	window.addEventListener('resize', setContentMargin);

	// 비밀번호 보기
	const hiddenShow = document.querySelectorAll('.js_hiddenShow');
	class hiddenShowBox {
		constructor(target) {
			this.target = target;
			this.hiddenShowBtn = this.target.querySelector('.hidden-show__btn');
			this.hiddenShowIp = this.target.querySelector(".hidden-show__input");
		}

		hiddenShowFn() {
			const _this = this;
			
			this.hiddenShowBtn.addEventListener("click" , function(){
				if(_this.hiddenShowIp.type === 'password'){
					_this.hiddenShowIp.type = 'text';
					_this.hiddenShowBtn.classList.add('on');
				}else{
					_this.hiddenShowIp.type = 'password';
					_this.hiddenShowBtn.classList.remove('on');
				}
			})
		}
	}    
	hiddenShow.forEach(el => {        
		new hiddenShowBox(el).hiddenShowFn();
	});
	
	//js-tag-swiper
	if(document.querySelector('.js-tag-swiper')){
		const tagSwiper = document.querySelectorAll('.js-tag-swiper');

		tagSwiper.forEach(el => {
			let _tagSwiper = new Swiper(el, {
				slidesPerView: 'auto',
			});
		});
	}

	//datepicker
	if(document.querySelector('.datepicker')){
		$(".datepicker input").datepicker({
			dateFormat: 'yy-mm-dd',
			showOtherMonths: true,
			prevText: '이전 달',
			nextText: '다음 달',
			monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			dayNames: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
			showMonthAfterYear: true,
			yearSuffix: '',
			firstDay:1
		});
	}

	// footer - floating 상단으로
	if(document.querySelector('.top-move')){
		const topMove = document.querySelector('.top-move');

		window.addEventListener('scroll' , ()=>{
			if(window.pageYOffset >= topMove.clientHeight){
				topMove.classList.add('scroll');
			} else {
				topMove.classList.remove('scroll');
			}
		})
	}
	
	//모바일 브라우저 이슈로 vh 재계산
	if(document.querySelector('.layer__con-area')){
		function resizeLayerConArea(){
			let reVh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${reVh}px`);
		}
		resizeLayerConArea();

		window.addEventListener('resize', () => {
			resizeLayerConArea();
		});
	}

	// input 한글방지
	if(document.querySelector('.no-korean')){
		const koreanRegex = /[ㄱ-ㅎㅏ-ㅣ가-힣]/;
		const koreanRegexGlobal = /[ㄱ-ㅎㅏ-ㅣ가-힣]/g;

		document.querySelectorAll('.no-korean').forEach(input => {
			input.addEventListener('beforeinput', e => {
				if (e.data && koreanRegex.test(e.data)) {
					e.preventDefault();
				}
			});

			input.addEventListener('input', e => {
				e.target.value = e.target.value.replace(koreanRegexGlobal, '');
			});
		});	
	}
});
